import React from "react";
import { Modal, Image } from "antd";

interface Student {
  id?: number;
  name: string;
  admission_no: string;
  grade: string;      // now gets grade name
  division: string;
  dob?: string;
  phone: string;
  blood_group: string;
  academic_period: string;
  photo?: string;
}

interface StudentViewModalProps {
  visible: boolean;
  onClose: () => void;
  student: Student | null;
}


const StudentViewModal: React.FC<StudentViewModalProps> = ({
  visible,
  onClose,
  student,
}) => {
  if (!student) return null;

  
const imageUrl = student.photo
  ? `${process.env.REACT_APP_BASE_URL}/storage/${student.photo}`
  : "/default-avatar.png";

  const formatDate = (dateString?: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={400}
      title={<span style={{ fontWeight: 600, fontSize: "18px" }}>Student Details</span>}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Image
          width={120}
          height={120}
          src={imageUrl}
          alt={student.name}
          style={{ borderRadius: "50%", objectFit: "cover", marginBottom: "16px" }}
        />
        <h2 style={{ fontSize: "20px", fontWeight: 600, marginBottom: "4px" }}>
          {student.name}
        </h2>

        <p style={{ color: "#6c757d", marginBottom: "16px" }}>
          <strong>Grade:</strong> {student.grade} &nbsp;|&nbsp;
          <strong>Division:</strong> {student.division}
          {student.dob && (
            <>
              &nbsp;|&nbsp; <strong>DOB:</strong> {formatDate(student.dob)}
            </>
          )}
        </p>

        <div style={{ width: "100%", textAlign: "left", fontSize: "14px", lineHeight: 1.6 }}>
          <p><strong>Admission No:</strong> {student.admission_no}</p>
          <p><strong>Phone:</strong> {student.phone}</p>
          <p><strong>Blood Group:</strong> {student.blood_group}</p>
          <p><strong>Academic Period:</strong> {student.academic_period}</p>
        </div>
      </div>
    </Modal>
  );
};

export default StudentViewModal;
